import { render, staticRenderFns } from "./dataOrigin.vue?vue&type=template&id=9e93d7ba&scoped=true&"
import script from "./dataOrigin.vue?vue&type=script&lang=js&"
export * from "./dataOrigin.vue?vue&type=script&lang=js&"
import style0 from "./dataOrigin.vue?vue&type=style&index=0&id=9e93d7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93d7ba",
  null
  
)

export default component.exports